import { render, staticRenderFns } from "./Pre_shipping.vue?vue&type=template&id=f4c0c4ca&"
import script from "./Pre_shipping.vue?vue&type=script&lang=js&"
export * from "./Pre_shipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports